<template>
  <div>
    <slot
      :page="page"
      :list="list"
      :total="total"
      :loading="loading"
      :errors="errors"
      :onPageChange="onPageCahnge"
    />
  </div>
</template>

<script>
import urls from "@/constants/urls";
import axios from "axios";
import { defineComponent } from "vue";

export default defineComponent({
  name: "OrgExternalDonorsProvider",
  props: {
    orgCustomerID: {
      type: [String, Number],
      required: true,
    },
    page: {
      type: Number,
      default: 1,
    },
    per_page: {
      type: Number,
      default: 15,
    },
  },
  data() {
    return {
      list: [],
      total: 0,
      loading: false,
      errors: [],
    };
  },
  computed: {
    hasMore() {
      return this.page < this.pageCount;
    },
    pageCount() {
      return Math.ceil(this.total / this.per_page);
    },
  },
  created() {
    this.fetchData();
    this.$root.$on("OrgExternalDonorsProvider:fetchData", () => {
      this.fetchData();
    });
  },
  methods: {
    onPageCahnge(page) {
      this.page = page;
      this.fetchData();
    },
    async fetchData() {
      this.loading = true;
      this.error = null;

      try {
        const url = urls.orgExternalDonors(this.orgCustomerID);

        const params = {
          page: this.page,
          per_page: this.per_page,
        };

        const response = await axios.get(url, { params });
        this.list = response.data?.data || [];
        this.total = response?.data?.meta?.total || 0;
      } catch (error) {
        this.errors = error.response?.data?.errors.map((e) => e.detail || e.message) || [
          error.message,
        ];
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>
